import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/util";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";

let _init = function() {
  // Initialize popovers for button elements (legacy support)
  // eslint-disable-next-line no-undef
  $(".popover-button").each(function() {
    // eslint-disable-next-line no-undef
    $(this).popover({ trigger: "hover" });
  });

  // Initialize all other popovers (respects data-trigger attribute)
  // eslint-disable-next-line no-undef
  $("[data-toggle=\"popover\"]:not(.popover-button)").popover();
};

$(document).on("turbolinks:load", _init);
$(document).ready(_init);
